var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUmbrella = function SvgUmbrella(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.988a.6.6 0 0 1 .6.6v1.299a10.28 10.28 0 0 1 9.357 7.706h-.001a1.54 1.54 0 0 1-.26 1.34 1.54 1.54 0 0 1-1.233.607v.001h-7.864v5.988a1.282 1.282 0 0 0 2.566 0 .6.6 0 0 1 1.2 0 2.484 2.484 0 0 1-4.238 1.755 2.48 2.48 0 0 1-.727-1.755v-5.988H3.528a1.55 1.55 0 0 1-1.23-.613 1.542 1.542 0 0 1-.255-1.335A10.28 10.28 0 0 1 11.4 3.887v-1.3a.6.6 0 0 1 .6-.599m0 3.082-.024-.003a9.08 9.08 0 0 0-8.775 6.84.344.344 0 0 0 .328.435l16.939-.001a.34.34 0 0 0 .274-.134.34.34 0 0 0 .053-.315 9.08 9.08 0 0 0-8.773-6.825z"
  })));
};
export default SvgUmbrella;